import { useBancoScope } from "@/contexts/BankImpersonationContext";
import { VerComoPersonasSelector } from "@/components/admin/VerComoPersonasSelector";

/**
 * "Ver como" del Portal Bancos: por persona (regla de Eduardo, 2026-10-27). La lista son las
 * personas con acceso al portal (broker, supervisores y operadores de cada banco, etc.) en
 * bloques por rol; al elegir a alguien se ve exactamente su vista. La opción de arriba es la
 * vista propia ("Super Admin" para el Super Admin).
 */
export function BankImpersonationSelector({
  className,
  compact = false,
}: {
  className?: string;
  /** Variante para el header móvil: botón más angosto (`compacto` del estándar). */
  compact?: boolean;
}) {
  const { persona, setPersona } = useBancoScope();
  return (
    <VerComoPersonasSelector
      rutas={["/admin/portal-bancos/%"]}
      seleccionadoEmail={persona?.email ?? null}
      seleccionadoNombre={persona?.nombre}
      onElegir={setPersona}
      onLimpiar={() => setPersona(null)}
      compacto={compact}
      className={className}
    />
  );
}
